import { Product } from './product';
import { SalesActionEnum } from './sales-action-enum';

export class Transition {
  membershipTransitionId: number = null;
  salesAction: SalesActionEnum = null;
  currentProduct: Product = null;
  nextProduct: Product = null;
}
